// ApplicationsContext.js
import React, { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const ApplicationsContext = createContext();

export const useApplications = () => useContext(ApplicationsContext);

export const ApplicationsProvider = ({ children }) => {
  const [pendingApplicationsCount, setPendingApplicationsCount] = useState(0);
  const [showApplicationNotification, setShowApplicationNotification] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check if notification has been dismissed in this session
    const notificationDismissed = sessionStorage.getItem("applicationNotificationDismissed");
    
    // Only fetch and potentially show notification if it hasn't been dismissed
    if (notificationDismissed !== "true") {
      fetchPendingApplicationsCount();
    } else {
      setLoading(false);
    }
  }, []);

  const fetchPendingApplicationsCount = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        setLoading(false);
        return;
      }
      
      const response = await axios.get("/api/interviews/fetchInterviews", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { stage: encodeURIComponent("Application pending") },
      });

      const interviews = response.data.interviews || [];
      const count = interviews.length;
      
      setPendingApplicationsCount(count);
      setShowApplicationNotification(count > 0);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching pending applications:", err);
      setLoading(false);
    }
  };

  const dismissNotification = () => {
    setShowApplicationNotification(false);
    // Store in session storage so it doesn't reappear in this session
    sessionStorage.setItem("applicationNotificationDismissed", "true");
  };

  return (
    <ApplicationsContext.Provider
      value={{ 
        pendingApplicationsCount, 
        showApplicationNotification, 
        dismissNotification,
        loading
      }}
    >
      {children}
    </ApplicationsContext.Provider>
  );
}; 